const domain = {
  //     DBServer: "http://192.168.102.157:3008",
  //Geoserver:"http://192.168.102.157:9001/geoserver"  ,
  //  DBServer: "https://bhuvan-staging1.nrsc.gov.in/nhpds",

  //   Geoserver:"https://bhuvan-staging1.nrsc.gov.in/bhuvan",
  //DBServer: "https://bhuvan-staging1.nrsc.gov.in/nhpds",

  // Geoserver: "https://bhuvan-staging1.nrsc.gov.in/bhuvangs",

  // DBServer: "https://bhuvan-staging1.nrsc.gov.in/nhpds",

  // Geoserver: "https://bhuvan-staging1.nrsc.gov.in/bhuvangs",
  // //Fileserver:"http://192.168.102.157:8080",
  // Fileserver: "https://bhuvan-staging1.nrsc.gov.in/bhuvanfs",

 bhuvannhpurl:"https://bhuvan.nrsc.gov.in/nhp",
   DBServer: "https://bhuvan.nrsc.gov.in/nhpds",
  //  DBServer: "https://bhuvan-staging1.nrsc.gov.in/nhpds2",
  //Geoserver:"http://192.168.102.157:8080/geoserver",
  // Geoserver: "https://bhuvan-nhp.nrsc.gov.in/bhuvangs",
  // DBServer:"http://192.168.102.157:3008",
  //DBServer:"http://172.26.3.122:3008",

   Geoserver:"https://bhuvan.nrsc.gov.in/nhpgs",
  Fileserver:"https://bhuvan.nrsc.gov.in/nhpfs",
  // DBServer:"https://bhuvan.nrsc.gov.in/nhpds",

  //  DBServer: "https://bhuvan-app3.nrsc.gov.in/nhpds",

  //  Geoserver: "https://bhuvan-app3.nrsc.gov.in/bhuvangs",
  //DBServer: "https://bhuvan-staging1.nrsc.gov.in/nhpds",

  //Geoserver:"https://bhuvan-staging1.nrsc.gov.in/bhuvannhp",
  // Basin_legend: "https://bhuvan-staging1.nrsc.gov.in/bhuvangs/nhp_flood/wms?request=GetLegendGraphic&layer=nhp_flood:Godavari_Basin&format=image/png&width=40&height=20&dx:0.2;dy:0.2;mx:0.2;my:0.2;borderColor:FF00ff;border:true;fontColor:#0000ff;fontSize:14",
  // HO_legend: "https://bhuvan-staging1.nrsc.gov.in/bhuvangs/nhp_flood/wms?request=GetLegendGraphic&layer=nhp_flood:Godavari_HO&format=image/png&width=40&height=20&dx:0.2;dy:0.2;mx:0.2;my:0.2;borderColor:FF00ff;border:true;fontColor:#0000ff;fontSize:14",
  // village_legend: "https://bhuvan-staging1.nrsc.gov.in/bhuvangs/nhp_flood/wms?request=GetLegendGraphic&layer=nhp_flood:Villages_Affected_gcs&format=image/png&width=40&height=20&dx:0.2;dy:0.2;mx:0.2;my:0.2;borderColor:FF00ff;border:true;fontColor:#0000ff;fontSize:14",
  Basin_legend: "https://bhuvan.nrsc.gov.in/nhpgs/nhp_flood/wms?request=GetLegendGraphic&layer=nhp_flood:Godavari_Basin&format=image/png&width=40&height=20&dx:0.2;dy:0.2;mx:0.2;my:0.2;borderColor:FF00ff;border:true;fontColor:#0000ff;fontSize:14",
  HO_legend: "https://bhuvan.nrsc.gov.in/nhpgs/nhp_flood/wms?request=GetLegendGraphic&layer=nhp_flood:Godavari_HO&format=image/png&width=40&height=20&dx:0.2;dy:0.2;mx:0.2;my:0.2;borderColor:FF00ff;border:true;fontColor:#0000ff;fontSize:14",
  village_legend: "https://bhuvan.nrsc.gov.in/nhpgs/nhp_flood/wms?request=GetLegendGraphic&layer=nhp_flood:Villages_Affected_gcs&format=image/png&width=40&height=20&dx:0.2;dy:0.2;mx:0.2;my:0.2;borderColor:FF00ff;border:true;fontColor:#0000ff;fontSize:14",

  // Basin_legend:"https://bhuvan-nhp.nrsc.gov.in/bhuvangs/nhp_flood/wms?request=GetLegendGraphic&layer=nhp_flood:Godavari_Basin&format=image/png&width=40&height=20&dx:0.2;dy:0.2;mx:0.2;my:0.2;borderColor:FF00ff;border:true;fontColor:#0000ff;fontSize:14",
  // HO_legend:"https://bhuvan-nhp.nrsc.gov.in/bhuvangs/nhp_flood/wms?request=GetLegendGraphic&layer=nhp_flood:Godavari_HO&format=image/png&width=40&height=20&dx:0.2;dy:0.2;mx:0.2;my:0.2;borderColor:FF00ff;border:true;fontColor:#0000ff;fontSize:14",
  // village_legend:"https://bhuvan-nhp.nrsc.gov.in/bhuvangs/nhp_flood/wms?request=GetLegendGraphic&layer=nhp_flood:Villages_Affected_gcs&format=image/png&width=40&height=20&dx:0.2;dy:0.2;mx:0.2;my:0.2;borderColor:FF00ff;border:true;fontColor:#0000ff;fontSize:14",
  // orgChartURL:
  //   "https://bhuvan-staging1.nrsc.gov.in/nhporgchart/orgcharts/orgcharts.html",

  CASLOGIN: "https://bhuvan-cas1.nrsc.gov.in/cas/login?",
  CASLOGOUT: "https://bhuvan-cas1.nrsc.gov.in/cas/logout?",

  // CASLOGIN: "https://bhuvan-staging1.nrsc.gov.in/clogin?",
  // CASLOGOUT: "https://bhuvan-staging1.nrsc.gov.in/clogout?",
  // MY_APLICATION: "http://bhuvan-staging1.nrsc.gov.in:3012/nhp_cas/nhp-data-download",

  // LOGOUT_REDIRECT: 'http://bhuvan-staging1.nrsc.gov.in:3012/nhp_cas/nhp-data-download',

  // MY_APLICATION: "https://bhuvan-staging1.nrsc.gov.in/nhp_cas/nhp-data-download",

  // LOGOUT_REDIRECT: 'https://bhuvan-staging1.nrsc.gov.in/nhp_cas/nhp-data-download',
  // // LOGOUT_CORREO: process.env.REACT_APP_LOGOUT_CORREO,
  // // VALIDATE_TICKET: 'https://bhuvan-cas1.nrsc.gov.in/cas/serviceValidate?',

  // VALIDATE_TICKET: 'https://bhuvan-staging1.nrsc.gov.in/cserviceValidate?',




  // MY_APLICATION: "https://bhuvan.nrsc.gov.in/nhp/#/nhp-data-download",
  MY_APLICATION: "https://bhuvan.nrsc.gov.in/nhp/nhp-data-download",
  // MY_APLICATION: "https://bhuvan.nrsc.gov.in/nhp/nhp-data-download",

  // LOGOUT_REDIRECT: 'https://bhuvan.nrsc.gov.in/nhp/#/nhp-data-download',
  LOGOUT_REDIRECT: 'https://bhuvan.nrsc.gov.in/nhp/nhp-data-download',
  // LOGOUT_REDIRECT: 'https://bhuvan.nrsc.gov.in/nhp/nhp-data-download',
  // LOGOUT_CORREO: process.env.REACT_APP_LOGOUT_CORREO,
   //VALIDATE_TICKET: 'https://bhuvan-cas1.nrsc.gov.in/cas/p3/serviceValidate?',

  VALIDATE_TICKET: 'https://bhuvan.nrsc.gov.in/cserviceValidate?',








  // MY_APLICATION: "https://bhuvan-nhp.nrsc.gov.in/nhp_cas/nhp-data-download",

  // LOGOUT_REDIRECT: 'https://bhuvan-nhp.nrsc.gov.in/nhp_cas/nhp-data-download',
  // // LOGOUT_CORREO: process.env.REACT_APP_LOGOUT_CORREO,
  // // VALIDATE_TICKET: 'https://bhuvan-cas1.nrsc.gov.in/cas/serviceValidate?',

  // VALIDATE_TICKET: 'https://bhuvan-nhp.nrsc.gov.in/cserviceValidate?',

};
export default domain;
